import script from "./CcButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CcButton.vue?vue&type=script&setup=true&lang=js"

import "./CcButton.vue?vue&type=style&index=0&id=3beaa059&lang=scss"

const __exports__ = script;

export default __exports__